import { render } from "./Superusers.vue?vue&type=template&id=a79610e8&scoped=true"
import script from "./Superusers.vue?vue&type=script&lang=js"
export * from "./Superusers.vue?vue&type=script&lang=js"

import "./Superusers.vue?vue&type=style&index=0&id=a79610e8&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79610e8"]])

export default __exports__